export default "__VITE_ASSET__P6i25PTv__"